import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import { FORM_TYPE_CHECKBOX, FORM_TYPE_FILE, FORM_TYPE_MULTISELECT, FORM_TYPE_TEXT, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0 } from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { PRIVATE_PROMOTION_LIST_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { concatMap, finalize } from "rxjs/operators";
import { NurseryManager } from "app/business/managers/nursery.manager";
var PromotionNewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionNewComponent, _super);
    function PromotionNewComponent(appComponent, router, location, genericService, photosphereManager, nurseryManager, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.photosphereManager = photosphereManager;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.selectedFiles = [];
        _this.titleText = "PROMOTION_NEW_COMPONENT_LABEL";
        _this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "PROMOTION_EDIT_COMPONENT_NAME", "name", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "PROMOTION_EDIT_COMPONENT_DESC", "desc", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_MULTISELECT, "PROMOTION_EDIT_COMPONENT_PRODUCTS", "products", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, null, null, null, null, _this.dropdownSettings),
            new FormInfoField(FORM_TYPE_MULTISELECT, "PROMOTION_EDIT_COMPONENT_NURSERIES", "nurseries", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, null, null, null, null, _this.dropdownSettings),
            new FormInfoField(FORM_TYPE_CHECKBOX, "PROMOTION_COMPONENT_FEATURED", "featured", [], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_FILE, "PROMOTION_COMPONENT_IMAGE", "image", [], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, undefined, undefined, ".jpg,.jpeg,.png", true)
        ];
        _this.formInfo = new FormInfo(formInfoFields, null);
        _this.subscribeGenericServices();
        return _this;
    }
    PromotionNewComponent.prototype.ngOnInit = function () {
        this.getProducts();
    };
    PromotionNewComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    PromotionNewComponent.prototype.getProducts = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.getProducts()
            .pipe(concatMap(function (products) {
            _this.formInfo.fields[2].values = products.map(function (prod) {
                var language = _this.photosphereManager.getCurrentLanguage();
                return {
                    id: prod.uuid,
                    text: _this.getProductName(prod, language)
                };
            });
            return _this.nurseryManager.getNurseries(true, 10000, 0);
        }), finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (_a) {
            var _ = _a[0], nurseries = _a[1];
            _this.formInfo.fields[3].values = nurseries.map(function (nursery) {
                return {
                    id: nursery.uuid,
                    text: nursery.name
                };
            });
            _this.formComponent.updateFormValues(_this.formInfo);
        });
    };
    PromotionNewComponent.prototype.onSavePromotion = function () {
        var _this = this;
        this.appComponent.startLoading();
        var newProds = this.formComponent.form.value.products.map(function (prod) { return prod.id; });
        var newNurseries = this.formComponent.form.value.nurseries.map(function (nursery) { return nursery.id; });
        this.photosphereManager.addPromotion({
            title: this.formComponent.form.value.name,
            description: this.formComponent.form.value.desc,
            featured: this.formComponent.form.value.featured
        }, { products: newProds }, { nurseries: newNurseries }, this.selectedFiles)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            _this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    };
    PromotionNewComponent.prototype.onFilesSelected = function (event) {
        this.selectedFiles = event;
    };
    PromotionNewComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    };
    PromotionNewComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    return PromotionNewComponent;
}(BaseComponent));
export { PromotionNewComponent };
